import { render, staticRenderFns } from "./SignupFormSimple.vue?vue&type=template&id=2de3ecb3&scoped=true&"
import script from "./SignupFormSimple.vue?vue&type=script&lang=js&"
export * from "./SignupFormSimple.vue?vue&type=script&lang=js&"
import style0 from "./SignupFormSimple.vue?vue&type=style&index=0&id=2de3ecb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de3ecb3",
  null
  
)

export default component.exports